export default __webpack_public_path__ + "static/media/exit.cc038967.svg";